module.exports = __webpack_public_path__ + "img/unrevealed1.4048dd7b.svg";